import { createFileRoute } from "@tanstack/react-router";
import { BookingsPage } from "@/app/connect/pages/bookings";

type BookingsSearchParams = {
	provider_id?: string;
};

function cleanId(value: unknown): string | undefined {
	if (typeof value === "number") return String(value);
	if (typeof value === "string") {
		const cleaned = value.replace(/^["']|["']$/g, "");
		return cleaned || undefined;
	}
	return undefined;
}

export const Route = createFileRoute("/connect/bookings")({
	validateSearch: (search: Record<string, unknown>): BookingsSearchParams => ({
		provider_id: cleanId(search.provider_id),
	}),
	component: BookingsPage,
});
